<template>
  <div class="promotion-center-container">
    <van-nav-bar :title="$t('promotion_center')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="content-top">
        <div class="content-top-left">
          <div class="left-top">{{ $t("invite_friende") }}</div>
          <div class="left-bot">{{ $t("invite_friends_commission") }}</div>
        </div>
        <div class="content-top-right" @click="goPromotionRule">
          {{ $t("promotion_rule") }}
          <img src="../../assets/arrow-right.svg" alt="" />
        </div>
      </div>

      <div class="content-mid" v-if="incomeInfo">
        <div class="content-mid-title">{{ $t("my_promotion") }}</div>
        <div class="content-mid-info">
          <div class="content-mid-info-item" v-if="incomeInfo">
            {{ $t("total_promotions") }}:
            {{
              incomeInfo.sub_user_list.length +
              incomeInfo.sub_sub_user_list.length +
              incomeInfo.sub_sub_sub_user_list.length
            }}
          </div>
          <div class="content-mid-info-item">
            {{ $t("commission_amount") }}: 
            <span v-if="incomeInfo.btc">{{ incomeInfo.btc }}BTC</span>
            <span v-if="incomeInfo.eth">{{ incomeInfo.eth }}ETH</span>
            <span v-if="incomeInfo.usdt">{{ incomeInfo.usdt }}USDT</span>
          </div>
        </div>
        <div class="content-mid-teamcount">
          <div class="content-mid-teamcount-item">
            <div class="item-top">{{ incomeInfo.sub_user_list.length }}</div>
            <div class="item-bot">{{ $t("generation_p") }}</div>
          </div>
          <div class="content-mid-teamcount-item">
            <div class="item-top">{{ incomeInfo.sub_sub_user_list.length }}</div>
            <div class="item-bot">{{ $t("second_generation_p") }}</div>
          </div>
          <div class="content-mid-teamcount-item">
            <div class="item-top">{{ incomeInfo.sub_sub_sub_user_list.length }}</div>
            <div class="item-bot">{{ $t("three_generations_p") }}</div>
          </div>
        </div>
        <div
          class="content-mid-row"
          v-clipboard:copy="userInfo.invite"
          v-clipboard:success="onCopy"
        >
          <div class="content-mid-row-left">
            <div class="title">{{ $t("invitation_code_y") }}:</div>
            <div class="text">{{ userInfo.invite }}</div>
          </div>

          <div class="content-mid-row-right">
            <img src="../../assets/promotion-copy.svg" alt="" />
          </div>
        </div>
        <div
          class="content-mid-row"
          v-clipboard:copy="inviteUrl"
          v-clipboard:success="onCopy"
        >
          <div class="content-mid-row-left">
            <div class="title">{{ $t("sponsored_link") }}:</div>
            <div class="text">{{ inviteUrl }}</div>
          </div>
          <div class="content-mid-row-right">
            <img src="../../assets/promotion-copy.svg" alt="" />
          </div>
        </div>
        <div class="content-mid-share" @click="showShareBox">
          <div class="content-mid-share-left">
            <img src="../../assets/share-btn-bg.png" alt="" />
            <div class="text">{{ $t("click_share") }}</div>
          </div>
          <div class="content-mid-share-right">
            <img src="../../assets/qrcode-icon.svg" alt="" />
          </div>
        </div>
        <div class="content-mid-detail" @click="goDetail">{{ $t("commission_details") }}</div>
      </div>

      <div class="content-bot">
        <div class="content-bot-title">{{ $t("my_promotion") }}</div>
        <van-tabs :ellipsis="false"
          v-model="active"
          title-active-color="#0062f8"
          color="#0062f8"
          animated
        >
          <van-tab :title="$t('generation')">
            <TeamList v-if="incomeInfo.sub_user_list" :teamList="incomeInfo.sub_user_list" />
          </van-tab>
          <van-tab :title="$t('second_generation')">
            <TeamList v-if="incomeInfo.sub_sub_user_list" :teamList="incomeInfo.sub_sub_user_list" />
          </van-tab>
          <van-tab :title="$t('three_generations')">
            <TeamList v-if="incomeInfo.sub_sub_sub_user_list" :teamList="incomeInfo.sub_sub_sub_user_list" />
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-popup v-model="show" round closeable>
      <div class="share-pop">
        <div class="share-pop-top">
          <div class="share-pop-top-left">
            <img src="../../assets/logo.png" alt="" />
          </div>
          <div class="share-pop-top-right">
            <div class="site-title">
              <img src="../../assets/text-logo.png" alt="" />
            </div>
            <div class="share-url">
              {{ inviteUrl }}
            </div>
          </div>
        </div>
        <div class="share-pop-bot">
          <div class="qrcode" ref="qrCodeUrl"></div>
          <div class="share-pop-bot-tip">{{ $t('QRcode_register') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import TeamList from "@/components/TeamList";
import QRCode from "qrcodejs2";

export default {
  components: {
    TeamList,
  },
  data() {
    return {
      show: false,
      active: 0,
      userInfo: "",
      inviteUrl: "",
      incomeInfo: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.inviteUrl =
      window.location.origin +
      "/host/" +
      JSON.parse(localStorage.getItem("userInfo")).invite;
    this.getShareStat();
  },
  methods: {
    goDetail() {
      this.$router.push('/income-detail')
    },
    async getShareStat() {
      const res = await this.$api.getShareStat();
      if (res.code == 200) {
        this.incomeInfo = res.data;
      }
    },
    showShareBox() {
      this.show = true;
      this.$nextTick(() => {
        this.createQrCode();
      });
    },
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    navBack() {
      this.$router.replace('/');
    },
    goPromotionRule() {
      this.$router.push("/promotion-rule");
    },
    createQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.inviteUrl,
        width: 175,
        height: 175,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-tabs__wrap {
  border-bottom: 1px solid #eee;
}
/deep/ .van-popup--round {
  border-radius: 5px;
}
.promotion-center-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    &-top {
      padding: 10px 15px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-left {
        font-size: 14px;
        .left-bot {
          font-size: 12px;
          color: #5a6e81;
        }
      }
      &-right {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #0062f8;
        img {
          width: 15px;
          height: 20px;
        }
      }
    }
    .content-mid {
      margin-top: 10px;
      background: #fff;
      padding: 15px 15px;
      &-title {
        font-weight: bold;
        font-size: 14px;
      }
      &-info {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #5a6e81;
        margin-top: 10px;
        &-item {
          flex: 1;
        }
      }
      &-teamcount {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;
        &-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          .item-bot {
            margin-top: 5px;
            color: #5a6e81;
          }
        }
      }
      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        &-left {
          display: flex;
          align-items: center;
          padding: 15px 0;
          font-size: 14px;
          .title {
            color: #707070;
            margin-right: 5px;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
      &-share {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-left {
          width: 297px;
          height: 38px;
          position: relative;
          text-align: center;
          line-height: 38px;
          font-size: 16px;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
          }
          .text {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            color: #fff;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 3px;
          border: 1px solid #0062f8;
          border-radius: 3px;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
      &-detail {
        width: 100%;
        margin-top: 15px;
        padding: 10px 0;
        background: #0062f8;
        color: #fff;
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        border-radius: 3px;
      }
    }
    .content-bot {
      background: #fff;
      margin-top: 15px;
      &-title {
        font-size: 14px;
        font-weight: bold;
        padding: 15px;
      }
    }
  }
  .share-pop {
    width: 240px;
    &-top {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      border-bottom: 1px solid #ddd;

      &-left {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 35px;
          height: 35px;
        }
      }
      &-right {
        width: 100px;
        box-sizing: border-box;
        margin-left: 10px;
        .site-title {
          display: flex;
          align-items: flex-end;
          img {
            width: 60px;
            height: auto;
          }
        }
        .share-url {
          word-break: break-all;
          font-size: 12px;
        }
      }
    }
    &-bot {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 0;
      &-tip {
        font-size: 12px;
        margin-top: 15px;
      }
    }
  }
}

@media (min-width: 640px) {
  /deep/ .van-tabs__wrap {
    border-bottom: 1px solid #eee;
    height: 50px;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    left: unset;
  }
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  .promotion-center-container {
    .back {
      width: 30px;
      height: 15px;
    }
    .content {
      &-top {
        padding: 10px 15px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-left {
          font-size: 14px;
          .left-bot {
            font-size: 12px;
            color: #5a6e81;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #0062f8;
          img {
            width: 15px;
            height: 20px;
          }
        }
      }
      .content-mid {
        margin-top: 10px;
        background: #fff;
        padding: 15px 15px;
        &-title {
          font-weight: bold;
          font-size: 14px;
        }
        &-info {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #5a6e81;
          margin-top: 10px;
          &-item {
            flex: 1;
          }
        }
        &-teamcount {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 15px;
          &-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            .item-bot {
              margin-top: 5px;
              color: #5a6e81;
            }
          }
        }
        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          &-left {
            display: flex;
            align-items: center;
            padding: 15px 0;
            font-size: 14px;
            .title {
              color: #707070;
              margin-right: 5px;
            }
          }
          &-right {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 18px;
              height: 18px;
            }
          }
        }
        &-share {
          margin-top: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &-left {
            flex: 1;
            width: 100%;
            height: 38px;
            position: relative;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            display: flex;
            align-items: center;
            margin-right: 10px;
            img {
              width: 100%;
              height: auto;
              position: absolute;
              left: 0;
            }
            .text {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              color: #fff;
            }
          }
          &-right {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
            border: 1px solid #0062f8;
            border-radius: 3px;
            img {
              width: 50px;
              height: 50px;
            }
          }
        }
        &-detail {
          width: 100%;
          margin-top: 15px;
          padding: 10px 0;
          background: #0062f8;
          color: #fff;
          font-size: 14px;
          text-align: center;
          font-weight: 600;
          border-radius: 3px;
        }
      }
      .content-bot {
        background: #fff;
        margin-top: 15px;
        &-title {
          font-size: 14px;
          font-weight: bold;
          padding: 15px;
        }
      }
    }
    .share-pop {
      width: 300px;
      &-top {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        border-bottom: 1px solid #ddd;

        &-left {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 35px;
            height: 35px;
          }
        }
        &-right {
          width: 100px;
          box-sizing: border-box;
          margin-left: 10px;
          .site-title {
            display: flex;
            align-items: flex-end;
            img {
              width: 60px;
              height: auto;
            }
          }
          .share-url {
            word-break: break-all;
            font-size: 12px;
          }
        }
      }
      &-bot {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 0;
        &-tip {
          font-size: 12px;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>